// Minimal slider-component replacement — safe, defensive, avoids NaN
(function () {
  function initSliders(scope) {
    // Scope defaults to document
    scope = scope || document;

    // Find all slider wrappers that match Studio's pattern
    var sliders = Array.from(scope.querySelectorAll('.slider, [id^="Slider-"], .product__media-list')).map(function(el){
      // If .product__media-list selects the UL, take its closest .slider wrapper if present
      if (el.classList.contains('product__media-list')) {
        var parentSlider = el.closest('.slider');
        return parentSlider || el;
      }
      return el;
    }).filter(Boolean);

    sliders.forEach(function(slider) {
      try {
        // find the list element and slides
        var list = slider.querySelector('.product__media-list') || slider.querySelector('ul') || slider;
        if (!list) return;

        var slides = Array.from(list.querySelectorAll('.product__media-item, .slider__slide, li'));
        if (slides.length === 0) return;

        // Setup counter display (safe fallback)
        var counterCurrent = slider.querySelector('.slider-counter--current');
        var counterTotal = slider.querySelector('.slider-counter--total');

        if (counterTotal) counterTotal.textContent = slides.length;
        if (counterCurrent && !counterCurrent.textContent) counterCurrent.textContent = 1;

        // find prev/next buttons if present
        var btnPrev = slider.querySelector('.slider-button--prev');
        var btnNext = slider.querySelector('.slider-button--next');

        // helper: get current index (based on .is-active or visible slide)
        function getCurrentIndex() {
          var active = slides.findIndex(function(s){ return s.classList.contains('is-active'); });
          if (active >= 0) return active;
          // fallback: compute nearest visible by left offset
          var visibleIndex = 0;
          try {
            var lefts = slides.map(function(s){ return s.offsetLeft; });
            var curScroll = (list.scrollLeft || 0);
            var diffs = lefts.map(function(l){ return Math.abs(l - curScroll); });
            visibleIndex = diffs.indexOf(Math.min.apply(null, diffs));
            if (visibleIndex === -1) visibleIndex = 0;
          } catch (e) { visibleIndex = 0; }
          return visibleIndex;
        }

        function updateActive(index) {
          slides.forEach(function(s,i){ s.classList.toggle('is-active', i === index); });
          if (counterCurrent) counterCurrent.textContent = (index + 1);
          // enable/disable buttons safely
          if (btnPrev) btnPrev.disabled = (index === 0);
          if (btnNext) btnNext.disabled = (index === slides.length - 1);
        }

        // safe scrollTo index
        function gotoIndex(i, smooth) {
          i = Math.max(0, Math.min(i, slides.length - 1));
          var target = slides[i];
          if (!target) return;
          try {
            // scroll so the slide's left aligns with wrapper left
            var parent = list;
            var left = target.offsetLeft;
            parent.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
            updateActive(i);
          } catch(e) {
            // fallback: set class only
            updateActive(i);
          }
        }

        // attach handlers to buttons
        if (btnPrev) {
          btnPrev.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = getCurrentIndex();
            gotoIndex(idx - 1, true);
          });
        }
        if (btnNext) {
          btnNext.addEventListener('click', function (e) {
            e.preventDefault();
            var idx = getCurrentIndex();
            gotoIndex(idx + 1, true);
          });
        }

        // expose keyboard navigation
        slider.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { gotoIndex(getCurrentIndex() + 1, true); }
          if (e.key === 'ArrowLeft') { gotoIndex(getCurrentIndex() - 1, true); }
        });

        // When user scrolls manually, update active slide and counter (throttled)
        var scrollTimer;
        list.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var idx = getCurrentIndex();
            updateActive(idx);
          }, 80);
        }, { passive: true });

        // Initialize: wait for images to load to avoid 0 widths
        var imgs = Array.from(list.querySelectorAll('img'));
        var loaded = 0;
        if (imgs.length === 0) {
          updateActive(0);
        } else {
          imgs.forEach(function(img){
            if (img.complete && img.naturalWidth > 0) {
              loaded++;
              if (loaded === imgs.length) updateActive(0);
            } else {
              img.addEventListener('load', function () {
                loaded++;
                if (loaded === imgs.length) updateActive(0);
              }, { once: true });
              img.addEventListener('error', function () {
                loaded++;
                if (loaded === imgs.length) updateActive(0);
              }, { once: true });
            }
          });
        }
      } catch (err) {
        // defensive: do not throw
        console.warn('slider-component init error', err);
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSliders(document); });
  } else {
    initSliders(document);
  }

  // Also re-run for dynamic content (if any)
  var mo = new MutationObserver(function(m){ initSliders(document); });
  mo.observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll("[data-slider]");
  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll(".slide");
    let index = 0;

    setInterval(() => {
      index = (index + 1) % slides.length;
      slider.scrollTo({
        left: index * slider.clientWidth,
        behavior: "smooth",
      });
    }, 3000);
  });
});
